import { FC } from 'react';
import { useLocation } from 'react-router-dom';

import { Box, Stack } from '@mui/material';
import clsx from 'clsx';
import { useBreakpoints } from 'hooks';

import { CloseButton } from 'components/_basic/CloseButton/CloseButton';
import { Drawer, LogoContainer, useDrawerState, useScrollingContext } from 'components/OnePageTemplates/common';
import { useGetNavSections } from 'components/OnePageTemplates/common/Navigation/constants';

import styles from './NavigationMenu.module.scss';

export const NavigationMenu: FC = () => {
  const { closeDrawerHandler, isDrawerOpened } = useDrawerState();
  const { isMobile } = useBreakpoints();
  const { sections } = useScrollingContext();
  const { hash } = useLocation();
  const navSections = useGetNavSections();

  if (!sections.length) {
    return null;
  }

  return (
    <Box className={styles.wrapper}>
      {isDrawerOpened && !isMobile && <CloseButton className={styles.close} onClick={closeDrawerHandler} />}
      <Drawer open={isDrawerOpened} onClose={closeDrawerHandler}>
        <Box className={styles.content}>
          <Stack direction="row" alignItems="start" justifyContent="space-between">
            <LogoContainer className={styles.logo} />
            {isMobile && <CloseButton className={styles.closeMobile} onClick={closeDrawerHandler} />}
          </Stack>
          <Stack spacing={{ sm: 5, xs: 4 }} mt={{ xs: 5, sm: 8 }}>
            {sections.map(({ name, hash: sectionHash, index }) => (
              <a
                key={sectionHash}
                href={`#${sectionHash}`}
                className={clsx(styles.navItem, { [styles.active]: hash.includes(sectionHash) })}
                onClick={closeDrawerHandler}
              >
                {navSections.find((item) => item.index === index)?.name ?? name}
              </a>
            ))}
          </Stack>
        </Box>
      </Drawer>
    </Box>
  );
};
